import { StickyNote } from 'lucide-react';

/**
 * V75 — la nota INTERNA come compare in tabella: troncata, col testo intero nel
 * tooltip nativo (`title`), nessuna libreria.
 *
 * Non è una colonna a sé: le tabelle richieste e ordini hanno già 8 e 6 colonne,
 * e una nona/settima le avrebbe strette tutte. Sta come seconda riga nella cella
 * CLIENTE — la cella di testo più larga, e quella che su /richieste ospita già
 * il badge della consultazione, cioè il posto dove l'informazione accessoria
 * della riga vive.
 */
export default function NotaInternaRiga({ nota }: { nota?: string | null }) {
  if (!nota) return null;
  return (
    <span
      title={nota}
      data-testid="nota-interna-riga"
      className="mt-0.5 flex items-center gap-1 text-[11px] font-normal text-ink-soft"
    >
      <StickyNote size={10} className="flex-shrink-0" />
      <span className="truncate">{nota}</span>
    </span>
  );
}
